import moment from 'moment';
// import momentRandom from 'moment-random';

export const dateWeeksBefore = (numberOfWeeksBefore) => {
  if (numberOfWeeksBefore === 0) {
    return moment().format('DD/MM/YY');
  }
  const weeksToDay = numberOfWeeksBefore * 7;
  return moment().subtract(weeksToDay, 'days').format('DD/MM/YY');
};

export const dateDayWeeksBefore = (numberOfWeeksBefore, daySinceBegining) => {
  if (numberOfWeeksBefore === 0) {
    return moment().format('DD/MM/YY');
  }
  const weeksToDay = numberOfWeeksBefore * 7;
  const weekBefore = moment().subtract(weeksToDay, 'days');
  return weekBefore.add(daySinceBegining, 'days').format('DD/MM/YY');
};

export const dateDayWeeksAfter = (numberOfWeeksAfter, daySinceBegining) => {
  if (numberOfWeeksAfter === 0) {
    return moment().format('DD/MM/YY');
  }
  const weeksToDay = numberOfWeeksAfter * 7;
  const weeksAfter = moment().add(weeksToDay, 'days');
  return weeksAfter.add(daySinceBegining, 'days').format('DD/MM/YY');
};

export const listOfDatesByDay = () => {
  return [
    dateDayWeeksBefore(5, 5),
    dateDayWeeksBefore(4, 1),
    dateDayWeeksBefore(4, 5),
    dateDayWeeksBefore(3, 1),
    dateDayWeeksBefore(3, 2),
    dateDayWeeksBefore(3, 5),
    dateDayWeeksBefore(2, 2),
    dateDayWeeksBefore(2, 3),
    dateDayWeeksBefore(2, 5),
    dateDayWeeksBefore(1, 3),
    dateDayWeeksBefore(1, 4),
    dateDayWeeksBefore(1, 5),
    dateDayWeeksBefore(0, 0)
  ];
};

export const listOfDatesByWeek = () => {
  return [
    dateWeeksBefore(4),
    dateWeeksBefore(3),
    dateWeeksBefore(2),
    dateWeeksBefore(1),
    dateWeeksBefore(0)
  ];
};
